'use client';

import { c as _c } from "react/compiler-runtime";
import { FactiiiRequirement } from '@shared/all/domains/factiiis';
import { createSourceSchema } from '@shared/all/validators';
import { Briefcase, Building, ChevronLeft, EyeOff, User } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../../utils/trpc';
import Button from '../../common/Button';
import Modal, { ModalHeader } from '../../HOC/Modal';
import Input from '../../UI/Input';
import { type SourceItem } from './SourceFactiii';
const sourceTypes = [{
  id: FactiiiRequirement.HUMAN_SOURCE,
  label: 'Human Source',
  icon: User
}, {
  id: FactiiiRequirement.GOVERNMENT_SOURCE,
  label: 'Government Source',
  icon: Briefcase
}, {
  id: FactiiiRequirement.ENTERPRISE_SOURCE,
  label: 'Enterprise Source',
  icon: Building
}, {
  id: FactiiiRequirement.ANONYMOUS_SOURCE,
  label: 'Anonymous Source',
  icon: EyeOff
}];
type Props = {
  factiiiName: string;
  addSource: (sources: SourceItem) => void;
  closeHandler: () => void;
};
const CreateSourceFactiii = props => {
  const $ = _c(30);
  const [description, setDescription] = useState("");
  const [sourceRequirement, setSourceRequirement] = useState(FactiiiRequirement.HUMAN_SOURCE);
  let t0;
  if ($[0] !== description || $[1] !== props || $[2] !== sourceRequirement) {
    t0 = async e => {
      e.preventDefault();
      const submit = createSourceSchema.safeParse({
        name: props.factiiiName,
        description,
        requirements: [sourceRequirement]
      });
      if (!submit.success) {
        console.error(submit.error);
        return;
      }
      const [error, data] = await client.factiiis.createSource.mutate(submit.data);
      if (error) {
        console.error(error);
        return;
      }
      if (data) {
        props.addSource(data);
        props.closeHandler();
      }
    };
    $[0] = description;
    $[1] = props;
    $[2] = sourceRequirement;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSubmit = t0;
  const t1 = props.closeHandler;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModalHeader>Create New Source Factiii</ModalHeader>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronLeft />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.closeHandler) {
    t4 = <div className="flex items-center gap-2"><Button text="Back" variant="CLEAR" onClick={props.closeHandler} icon={t3} />If you want to change the name go back and updated your search.</div>;
    $[6] = props.closeHandler;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.factiiiName) {
    t5 = <Input label="Name" value={props.factiiiName} onChange={_temp} disabled={true} />;
    $[8] = props.factiiiName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== description) {
    t7 = <div><Input value={description} onChange={setDescription} label="Enter source description..." /></div>;
    $[13] = description;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <label className="mb-1 block text-sm font-emphasis text-textSecondary">Source Type</label>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== sourceRequirement) {
    t9 = sourceTypes.map(type => {
      const Icon = type.icon;
      return <button key={type.id} type="button" onClick={() => setSourceRequirement(type.id)} className={`flex items-center gap-2 rounded-md p-2 text-sm ${sourceRequirement === type.id ? "bg-background-secondary text-textPrimary" : "text-textSecondary hover:bg-background-light"}`}><Icon size={16} />{type.label}</button>;
    });
    $[16] = sourceRequirement;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div>{t8}<div className="grid grid-cols-2 gap-2">{t9}</div></div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== handleSubmit) {
    t11 = <Button type="submit" text="Create Source" variant="PRIMARY" onClick={handleSubmit} classNames="w-full" />;
    $[20] = handleSubmit;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t6 || $[25] !== t7) {
    t12 = <div className="space-y-4 p-4">{t6}{t7}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t6;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== props.closeHandler || $[28] !== t12) {
    t13 = <Modal closeHandler={t1}>{t2}{t12}</Modal>;
    $[27] = props.closeHandler;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default CreateSourceFactiii;
function _temp() {}